
import React, {ChangeEvent, useState} from "react";
import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'
import { InputPhoneProps } from "./InputPhone.types";

import "./InputPhone.scss";

export const InputPhone: React.FC<InputPhoneProps> = ({
                                                          inputlabel,
                                                          required,
                                                          value,
                                                          error= false,
                                                          errorMessage,
                                                          disabled,
                                                          tabIndex,
                                                          onTextChange
}) => {

    const handleChange = (phone: string) => {
        if(onTextChange){
            onTextChange(phone);
        }
    }

  return(
      <div className={"input-wrapper"}>
          {inputlabel && <label htmlFor={"input-general"}>{required && '*'} {inputlabel}</label> }
          <PhoneInput
              // inputClass={error ? `input-error` : ''}
              country={'il'}
              value={value}
              disabled={disabled}
              onChange={phone => handleChange(phone)}
              inputProps={{tabIndex:tabIndex}}
          />
          {error && <p className={"error-message"}>{errorMessage}</p>}
      </div>
  )
};

